import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Grid, styled, Typography } from '@mui/material';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import BookingHeader from '../components/BookingInfo/BookingHeader';
import Documents from '../components/BookingInfo/Documents';
import Qualifications from '../components/BookingInfo/Qualifications';
import CrtAvailability from '../components/Calendar/CrtAvailability';
import Loading from '../components/Loading';
import { addCrtToList } from '../redux/SchoolSlice';

// const useStyles = makeStyles(theme => ({
//     // teacherCardInfo: {
//     //     order: 2,
//     //     // [theme.breakpoints.up('sm')]: {
//     //     //     order: 1,
//     //     // },
//     // },
//     // bookingDateValue: {
//     //     padding: '0 0 10px 4px',
//     // },
// }));

const TeacherCard = styled('div')(({ theme }) => ({
    margin: '20px 20px 40px',
    padding: '20px',
}));

const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

const validPermission = 'create:booking';

export const ViewCrtProfile = props => {
    // const classes = useStyles();
    let { id } = useParams();
    //const id = 0;

    const { getAccessTokenSilently } = useAuth0();

    const { token } = useSelector(state => state.token);
    const tokenStatus = useSelector(state => state.token.status);

    const dispatch = useDispatch();

    let history = useHistory();

    const [state, setState] = useState({
        grade: [],
        processingBooking: 0,
        bookingResponse: '',
        saved: false,
    });
    const [schoolState, setSchoolState] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (tokenStatus === 'succeeded' && token.Count === 1) {
            if (token.permissions.includes(validPermission) === false)
                setState({
                    ...state,
                    redirectToHome: true,
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenStatus, token.Count, token.permissions]);

    function goBack() {
        history.push('/casual-relief-teacher-list');
    }

    // Get school state
    useEffect(() => {
        const schoolAddress = props.school.Data.address;
        setSchoolState(schoolAddress.match(/\b([A-Z]{2,3})\b/)[1]);
    }, [props.school]);

    useEffect(() => {
        //Check if the list has the user in it.
        if (props.schoolStatus === 'succeeded') {
            if (typeof props.school.Data.crtList !== 'undefined') {
                if (
                    props.school.Data.crtList.find(
                        item =>
                            item.uniqueId ===
                            props.list.responseVals[id].uniqueId
                    )
                ) {
                    setState({
                        ...state,
                        saved: true,
                    });
                } else {
                    setState({
                        ...state,
                        saved: false,
                    });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.school.count]);

    const saveCrtToList = async appointment => {
        try {
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            let requestData = {
                token: token,
                request: { pk1: props.list.responseVals[id].pk1 },
            };
            const outcome = dispatch(addCrtToList(requestData));
            setState({ ...state, saved: true });
            console.log('outcome', JSON.stringify(outcome));
        } catch (err) {
            console.log('Error occurred adding CRT', err);
            setState({
                ...state,
                apiMessage: 'Error occurred adding CRT',
            });
        }
    };

    return (
        <Grid
            container
            directon="row"
            justifyContent="center"
            alignItems="center"
        >
            <Grid item xs={12} sm={10}>
                <TeacherCard>
                    <CardHeader
                        sx={{ 'padding': '0px' }}
                        action={
                            <IconButton
                                onClick={goBack}
                                aria-label="settings"
                                size="large"
                            >
                                <CloseIcon />
                            </IconButton>
                        }
                    />
                    <div>
                        <Grid
                            container
                            directon="column-reverse"
                            alignItems="stretch"
                        >
                            <BookingHeader
                                booking={{
                                    'teacherProfile':
                                        props.list.responseVals[id]
                                            .profileImage,
                                    'teacherFirstName':
                                        props.list.responseVals[id].firstName,
                                    'teacherLastName':
                                        props.list.responseVals[id].lastName,
                                    'teacherBio':
                                        props.list.responseVals[id].bio,
                                }}
                                licenceList={
                                    props.list.responseVals[id].licenceList
                                }
                                schoolState={schoolState}
                                teacherRating={
                                    props.list.responseVals[id].rating
                                }
                                teacherRatingAmount={
                                    props.list.responseVals[id].amountOfRatings
                                }
                                userType="School"
                            />
                        </Grid>

                        <Grid container>
                            <Qualifications
                                skills={props.list.responseVals[id].skills}
                                otherSkills={
                                    props.list.responseVals[id].otherSkills
                                }
                                grades={props.list.responseVals[id].grades}
                                gs1pk={props.list.responseVals[id]['gs1-pk']}
                                schoolId={props.school.Data.pk1}
                            />
                        </Grid>

                        <Grid
                            container
                            directon="column-reverse"
                            alignItems="stretch"
                            sx={{ marginTop: '30px' }}
                        >
                            <Grid item xs={12}>
                                <Documents
                                    gs1pk={props.list.responseVals[id]['pk1']}
                                    schoolId={props.school.Data.pk1}
                                    loadOnInit={false}
                                    filterResume={false}
                                />
                            </Grid>
                            {state.saved ? (
                                <BookingButton
                                    disabled
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                >
                                    Saved
                                </BookingButton>
                            ) : (
                                <BookingButton
                                    onClick={saveCrtToList}
                                    data-cy="add-to-list"
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                >
                                    Add to List
                                </BookingButton>
                            )}

                            <BookingButton
                                onClick={goBack}
                                data-cy="back"
                                variant="outlined"
                                color="secondary"
                                size="large"
                            >
                                Back
                            </BookingButton>
                        </Grid>

                        <Grid container>
                            <CrtAvailability
                                reduced
                                id={props.list.responseVals[id].pk1}
                            />
                        </Grid>
                    </div>
                </TeacherCard>
            </Grid>
        </Grid>
    );
};

export default withAuthenticationRequired(ViewCrtProfile, {
    onRedirecting: () => <Loading />,
});
